import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function PackageCard({ pkg }) {
  const { tag, title, price, body, tiers, cta, href, highlight } = pkg;
  return (
    <div className={`bg-card rounded-[10px] p-7 border ${highlight ? "border-2 border-brand-teal shadow-md" : "border-border"}`}>
      <div className="flex flex-wrap items-start justify-between gap-3 mb-3">
        <div>
          <span className="inline-block text-[11px] font-bold tracking-wider px-2.5 py-1 rounded-full bg-accent text-accent-foreground mb-2">
            {tag}
          </span>
          <h3 className="text-xl font-bold text-brand-navy">{title}</h3>
        </div>
        <p className="text-lg font-extrabold text-brand-teal">{price}</p>
      </div>
      <p className="text-sm text-muted-foreground leading-relaxed">{body}</p>
      {tiers && (
        <ul className="mt-4 grid sm:grid-cols-3 gap-3">
          {tiers.map((t) => (
            <li key={t.name} className="rounded-[10px] bg-muted/60 border border-border p-3 text-sm">
              <span className="font-bold text-brand-navy">{t.name}</span> {t.price}
              <span className="block text-xs text-muted-foreground mt-0.5">{t.scope}</span>
            </li>
          ))}
        </ul>
      )}
      <Button asChild className="mt-5 bg-brand-teal hover:bg-brand-teal/90 text-white font-semibold">
        <Link to={href}>{cta}</Link>
      </Button>
    </div>
  );
}